import {
  TableChartConfigDto,
  PitcherReportChartConfigDto,
  BatterReportChartConfigDto,
  BatterSessionReportChartConfigDto,
  BatterSingleSessionReportChartConfigDto,
  PitcherSessionReportChartConfigDto,
  PitcherSingleSessionReportChartConfigDto,
  UmpireReportChartConfigDto,
  UmpireReportForAdminChartConfigDto,
  UmpireReportForSessionChartConfigDto,
  ChartType,
  PracticeBatterSingleSessionReportChartConfigDto,
  PracticeBatterSessionReportChartConfigDto,
  PracticePitcherSingleSessionReportChartConfigDto,
  PracticePitcherSessionReportChartConfigDto,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericDraggableCheckboxConfig from 'components/Configs/GenericDraggableCheckboxConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';

type ReportConfig =
  | BatterReportChartConfigDto
  | BatterSessionReportChartConfigDto
  | BatterSingleSessionReportChartConfigDto
  | PitcherReportChartConfigDto
  | PitcherSessionReportChartConfigDto
  | PitcherSingleSessionReportChartConfigDto
  | PracticeBatterSessionReportChartConfigDto
  | PracticeBatterSingleSessionReportChartConfigDto
  | PracticePitcherSessionReportChartConfigDto
  | PracticePitcherSingleSessionReportChartConfigDto
  | UmpireReportChartConfigDto
  | UmpireReportForSessionChartConfigDto
  | UmpireReportForAdminChartConfigDto;

type Props<TReportConfig extends ReportConfig> = ChartConfigProps<TableChartConfigDto, TReportConfig> & {
  chartId: ChartType;
  configKey: keyof TReportConfig;
  disabledVisibleStats?: string[];
  children?: ReactNode;
};

const TableChartSidebar = <T extends ReportConfig>({
  chartConfig,
  setTempLayout,
  tempLayout,
  chartId,
  configKey,
  disabledVisibleStats = [],
  children,
}: Props<T>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle(chartId as ChartType, chartConfig)}
      </Typography>
      {children}
      <GenericDraggableCheckboxConfig
        label={t('Visible stats')}
        draggableCheckboxes={chartConfig.visibleStats}
        setDraggableCheckboxes={(draggableCheckboxes) => {
          setTempLayout({
            ...tempLayout,
            [configKey]: {
              ...tempLayout[configKey],
              visibleStats: draggableCheckboxes,
            },
          });
        }}
        useShortLabels={true}
        disabledKeys={disabledVisibleStats}
      />
    </div>
  );
};

export default TableChartSidebar;
